import { __assign, __rest } from "tslib";
import * as React from 'react';
function selectText(element) {
    var ctr = 'createTextRange';
    var body = document.body;
    if (element && document.createRange && window.getSelection) {
        var range = document.createRange();
        var sel = window.getSelection();
        sel && sel.removeAllRanges();
        try {
            range.selectNodeContents(element);
        }
        catch (e) {
            range.selectNode(element);
        }
        sel && sel.addRange(range);
    }
    else if (typeof body[ctr] === 'function') {
        var range = body[ctr]();
        range.moveToElementText(element);
        range.select();
    }
    else {
        return false;
    }
    return true;
}
var CopiedInfo = function () { return (React.createElement("div", { className: "copy-info" },
    React.createElement("i", { className: "fas fa-check" }),
    " Copied to clipboard.")); };
export var ClipboardText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = React.useState(false), copied = _b[0], setCopied = _b[1];
    var el = React.useRef(undefined);
    React.useEffect(function () {
        if (copied) {
            var id_1 = setTimeout(function () { return setCopied(false); }, 3000);
            return function () { return clearInterval(id_1); };
        }
        return function () { };
    }, [copied]);
    var copyContent = function () {
        var element = el.current;
        if (selectText(element)) {
            document.execCommand('Copy');
            setCopied(true);
        }
    };
    return (React.createElement("div", __assign({}, props, { className: "message-frame clipboard-text" }),
        React.createElement("output", { ref: el, onClick: copyContent }, children),
        copied && React.createElement(CopiedInfo, null)));
};
//# sourceMappingURL=index.js.map